/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RankingOptions = {
  ranker?: string | undefined;
  scoreThreshold?: number | undefined;
};

/** @internal */
export const RankingOptions$inboundSchema: z.ZodType<
  RankingOptions,
  z.ZodTypeDef,
  unknown
> = z.object({
  ranker: z.string().optional(),
  score_threshold: z.number().optional(),
}).transform((v) => {
  return remap$(v, {
    "score_threshold": "scoreThreshold",
  });
});
/** @internal */
export type RankingOptions$Outbound = {
  ranker?: string | undefined;
  score_threshold?: number | undefined;
};

/** @internal */
export const RankingOptions$outboundSchema: z.ZodType<
  RankingOptions$Outbound,
  z.ZodTypeDef,
  RankingOptions
> = z.object({
  ranker: z.string().optional(),
  scoreThreshold: z.number().optional(),
}).transform((v) => {
  return remap$(v, {
    scoreThreshold: "score_threshold",
  });
});

export function rankingOptionsToJSON(rankingOptions: RankingOptions): string {
  return JSON.stringify(RankingOptions$outboundSchema.parse(rankingOptions));
}
export function rankingOptionsFromJSON(
  jsonString: string,
): SafeParseResult<RankingOptions, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RankingOptions$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RankingOptions' from JSON`,
  );
}
